import { SvgIcon } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { WithBrand } from '@websrc/App/Components/WithBrand'
import { exists } from '@websrc/DataMappers/Helpers/tsPattern'
import { TeacherHubProduct } from '@websrc/DataMappers/mapTeacherHubProducts'
import clsx from 'clsx'
import { Link } from 'gatsby'
import { styles, typography } from 'leds'
import React from 'react'
import { match } from 'ts-pattern'

interface SidebarProductMenuItemProps {
  product: TeacherHubProduct
}

export const SidebarProductMenuItem: React.FC<SidebarProductMenuItemProps> = ({ product }) => {
  return (
    <div className={styles({ paddingY: 10 })} data-testid={`product-select-${product.name}`}>
      {match(product)
        .with({ image: exists }, ({ schoolGrade, image, url, productLine, segment }) => (
          <Link className={styles({ display: 'flex' })} to={url}>
            <div className={styles({ flexBasis: 150, flexGrow: 0, flexShrink: 0 })}>
              <Asset
                sizes={'(min-width: 1024px) 150px'}
                srcSetWidths={[150]}
                thumbnail={image}
                width={150}
              />
            </div>
            <div className={styles({ paddingLeft: 10 })}>
              <p
                className={clsx(
                  typography({ size: 'xs' }),
                  styles({ display: 'flex', alignItems: 'center', marginBottom: 8 })
                )}
              >
                <SvgIcon name={'GRADE'} size={13} strokeWidth={3} title={schoolGrade} />
                <span className={styles({ paddingLeft: 5 })}>{schoolGrade}</span>
              </p>
              <p
                className={clsx(
                  typography({ size: 'xs', color: 'grey' }),
                  styles({ display: 'flex', alignItems: 'center' })
                )}
              >
                <WithBrand title={'{brand}'} />
              </p>
              <p
                className={clsx(
                  typography({ size: 'md', weight: 'bold' }),
                  styles({ whiteSpace: 'normal' })
                )}
              >
                {productLine}
              </p>
              <p
                className={clsx(
                  typography({ size: 'md', weight: 'bold' }),
                  styles({ whiteSpace: 'normal' })
                )}
              >
                {segment}
              </p>
            </div>
          </Link>
        ))
        .otherwise(() => (
          <Link
            className={styles({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            })}
            to={product.url}
          >
            <div>
              <p
                className={clsx(
                  typography({ size: 'md', weight: 'bold' }),
                  styles({ whiteSpace: 'normal' })
                )}
              >
                {product.productLine}
              </p>
              <p
                className={clsx(
                  typography({ size: 'md', weight: 'bold' }),
                  styles({ whiteSpace: 'normal' })
                )}
              >
                {product.segment}
              </p>
            </div>

            <p
              className={clsx(
                typography({ size: 'xs' }),
                styles({ display: 'flex', alignItems: 'center' })
              )}
            >
              <SvgIcon name={'GRADE'} size={13} strokeWidth={3} title={product.schoolGrade} />
              <span className={styles({ paddingLeft: 5 })}>{product.schoolGrade}</span>
            </p>
          </Link>
        ))}
    </div>
  )
}
